export const ApplicationIberiaCardsStep = {
  SALE_POINT_AND_PRODUCT: 'SALE_POINT_AND_PRODUCT',
  SHORT_CONTACT_FORM: 'SHORT_CONTACT_FORM',
} as const;

export type ApplicationIberiaCardsStepValue =
  (typeof ApplicationIberiaCardsStep)[keyof typeof ApplicationIberiaCardsStep];
